import {
  LOAD_APPLICATION_STATE,
  LOAD_APPLICATION_STATE_FAILURE,
  LOAD_APPLICATION_STATE_SUCCESS,
  SAVE_APPLICATION_STATE,
  SAVE_APPLICATION_STATE_FAILURE,
  SAVE_APPLICATION_STATE_SUCCESS,
} from "../types";

export type LoadStatus = "idle" | "loading" | "loaded" | "error";
export type SaveStatus = "idle" | "saving" | "saved" | "error";

export interface PersistenceState {
  loadStatus: LoadStatus;
  saveStatus: SaveStatus;
  error: string | null;
  updatedAt: string | null;
}

const initialState: PersistenceState = {
  loadStatus: "idle",
  saveStatus: "idle",
  error: null,
  updatedAt: null,
};

type PersistenceAction =
  | { type: typeof LOAD_APPLICATION_STATE }
  | { type: typeof LOAD_APPLICATION_STATE_SUCCESS; updatedAt: string | null }
  | { type: typeof LOAD_APPLICATION_STATE_FAILURE; error: string }
  | { type: typeof SAVE_APPLICATION_STATE }
  | { type: typeof SAVE_APPLICATION_STATE_SUCCESS; updatedAt: string }
  | { type: typeof SAVE_APPLICATION_STATE_FAILURE; error: string };

const persistenceReducer = (state = initialState, action: PersistenceAction): PersistenceState => {
  switch (action.type) {
    case LOAD_APPLICATION_STATE:
      return { ...state, loadStatus: "loading", error: null };
    case LOAD_APPLICATION_STATE_SUCCESS:
      return {
        ...state,
        loadStatus: "loaded",
        updatedAt: action.updatedAt,
      };
    case LOAD_APPLICATION_STATE_FAILURE:
      return { ...state, loadStatus: "error", error: action.error };
    case SAVE_APPLICATION_STATE:
      return { ...state, saveStatus: "saving", error: null };
    case SAVE_APPLICATION_STATE_SUCCESS:
      return { ...state, saveStatus: "saved", updatedAt: action.updatedAt };
    case SAVE_APPLICATION_STATE_FAILURE:
      return { ...state, saveStatus: "error", error: action.error };
    default:
      return state;
  }
};

export default persistenceReducer;
